import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import router from "./router/index.js";

import '@/assets/styles/index.scss'
import "@/assets/font/text.scss";

import "element-ui/lib/theme-chalk/index.css";
// 分页组件
import Pagination from "./components/Pagination/index.vue";
Vue.use(ElementUI);
Vue.component("Pagination", Pagination);

Vue.config.productionTip = false;
import * as echarts from "echarts";
import "@/assets/font/text.scss";


Vue.prototype.$echarts = echarts;
// new Vue({
//   render: (h) => h(App),
// }).$mount("#app");
new Vue({
  el: "#app",
  router,
  render: (h) => h(App),
});
